import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { DialogConfirmOptions } from '@shared/models';

@Component({
  selector: 'app-dialog-confirm',
  templateUrl: './dialog-confirm.component.html',
  styleUrls: ['./dialog-confirm.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true
})
export class DialogConfirmComponent {
  public readonly bsModalRef = inject(BsModalRef);

  result: boolean | null = null;

  options: DialogConfirmOptions = {
    title: 'Änderungen speichern',
    message: 'Einige Daten wurden geändert. Möchtest Du die Änderungen speichern?',
    yes: 'Ja',
    no: 'Nein',
    hideCloseButton: true
  };

  confirm() {
    this.result = true;
    this.bsModalRef.hide();
  }

  cancel() {
    this.result = false;
    this.bsModalRef.hide();
  }
}
